import { Injectable } from '@angular/core'
import { Affiliation } from '../models/affiliation'
import { Observable } from 'rxjs'
import { first, map } from 'rxjs/operators'

import { ApiService } from './api.service'
import { Mapper } from './mapper.service'

@Injectable({
  providedIn: 'root'
})
export class AffiliationService {

  constructor(private api: ApiService) {
    // noop
  }

  public findAncestors(orgId: number, active: boolean = false): Observable<Affiliation[]> {
    let query = `affiliations?descendent_organization_id=${orgId}`
    if (active) query += `&credential_status=active`
    return this.api.get(query)
      .pipe(first())
      .pipe(map(data => {
        return Mapper.asArray<Affiliation>(data.result, Affiliation)
      }))
  }

}
